import React from "react";

export default function OnlinePricingTable({
  title,
  highlight,
  secondTitle,
  subtitle,
  plans = [],
}) {
  return (
    <section className="pricing-section py-5">
      <div className="container text-center">
        {/* TITLE */}
        <h2 className="main-title FS40FW600">
          {title} <span className="text-success FS40FW600">{highlight}</span> {secondTitle}
        </h2>

        <p className="quote-para FS18FW400 fw-500">{subtitle}</p>

        {/* CARDS */}
        <div className="row justify-content-center mt-5">
          {plans.map((plan, i) => (
            <div className="col-lg-4 col-md-12 mb-4" key={i}>
              <div className={`pricing-card compare-card text-start ${plan.isPopular ? "active" : ""}`} style={{ cursor: 'pointer' }} onClick={() => window.location.href = plan.buttonLink || '/auth/register'}>
                {/* BADGE */}
                {(plan.isPopular && plan.badgeText)&& (
                  <div className="pricing-badge d-flex gap-2">
                    <img src="/images/web-new-images/crownPrice.svg" alt="PrimeIcon" />{plan.badgeText || "BEST SELLER"}
                  </div>
                )}

                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div style={{maxWidth:'250px'}}>
                    <p className="FS24FW500 fw-600">{plan.title}</p>
                    <p className="plus-sans FS14FW600">{plan.description}</p>
                  </div>
                  <div>
                    <span className="plus-sans FS12 fw-500">Starting Price <img src="/images/web-new-images/PrimeIcon.svg" alt="PrimeIcon" /></span>
                    <div className="FS40FW600 text-end">
                     ${plan.price}
                    </div>
                  </div>
                </div>

                {/* FEATURES */}
                <ul className="feature-list">
                  {plan.features.map((f, i) => (
                    <li key={i}>
                    {f}
                    </li>
                  ))}
                </ul>

                {/* BUTTON */}
                <button
                  className={`${plan.isPopular ? "primary-btn w-100" : "plan-btn "} btn-position plus-sans FS16FW500`}
                  onClick={() => window.location.href = plan.buttonLink || '/auth/register'}
                >
                  {plan.buttonText}{" "}
                    <img
                      src={`/images/web-new-images/${plan.isPopular ? "right-arrow.svg" : "right-arrow-black.svg"}`}
                      alt="Register Now"
                    />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}